import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { connect, useDispatch, useSelector } from 'react-redux';
import { APPRAISAL_SEARCH_HISTORY } from '../store/actions/types';
import * as userAction from '../store/actions/user.action';
import { RootState } from '../store/reducers';
import { Logout, handleToast, isValidEmail, splitName } from '../utils/handler';

interface InitialUserDetails {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  preferredContact: string;
}
let initialUserDetails: InitialUserDetails = { firstName: '', lastName: '', email: '', phone: '', preferredContact: 'Email' };
export const Profile: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const { myProfile } = useSelector((state: RootState) => state.userReducer);
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);

  const [userDetails, setUserDetails] = useState<InitialUserDetails>(initialUserDetails);
  const [phoneValidationError, setPhoneValidationError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name;
    let value = e.target.value;
    setUserDetails({
      ...userDetails,
      [name]: value,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(myProfile)) {
      setUserDetails({ ...myProfile, ...splitName(myProfile.name) });
    }
  }, [myProfile]);

  const checkFormValidation = () => {
    let { email = '', firstName = '' } = userDetails;

    let isValid = true;
    if (firstName === '' || email === '' || isValidEmail(email)) {
      isValid = false;
    } else if (userDetails.phone && !isValidPhoneNumber(userDetails.phone)) {
      setPhoneValidationError('Invalid phone number');
      isValid = false;
    } else if (phoneValidationError) {
      isValid = false;
    }
    return isValid;
  };

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    let { email = '', firstName = '', preferredContact = 'Email', lastName = '', phone = '' } = userDetails;
    let payload = {
      name: firstName + ' ' + lastName,
      email,
      phone: phone || '',
      preferredContact,
    };
    setFormSubmitted(true);
    if (checkFormValidation()) {
      userAction.updateMyProfile(payload).then((res) => {
        if (res) {
          handleToast({ message: res }, 'success');
        }
        setFormSubmitted(false);
      });
    }
  };

  const phoneNumberChange = (value: any) => {
    if (!value || (value && isValidPhoneNumber(value))) {
      setPhoneValidationError('');
    }
    if (formSubmitted && value && !isValidPhoneNumber(value)) {
      setPhoneValidationError('Invalid phone number');
    }
    setUserDetails({ ...userDetails, phone: value });
  };
  const logoutProfile = () => {
    dispatch({ type: APPRAISAL_SEARCH_HISTORY, payload: [] });
    Logout();
  };
  return (
    <div className="">
      <Helmet>
        <title>User Profile - Saw.com Domain Name Brokerage</title>
      </Helmet>

      <div className="container  ">
        <div className="fs-25 f-bold  text-center mt-4">My Profile</div>
        {/* <div className="mt-1 row justify-content-center">
          <button className="fs-11 btn-primary primary-dark btn btn-normal " onClick={() => history.push('/appraisal')}>
            <span className="">Back to Dashboard</span>
          </button>
        </div> */}
        <div className="d-flex justify-content-center profile-body ">
          <form noValidate className={'d-md-flex col-lg-10 flex-wrap profile-form was-validated ' + (formSubmitted ? ' was-validated' : ' ')} onSubmit={submit}>
            <div className="form-group col-md-6">
              <label className=" fw-600">{t('First Name')}</label>
              <input autoComplete="off" type="text" className="form-control saw-input" name="firstName" placeholder={t('Enter First name')} value={userDetails.firstName} onChange={handleChange} required />
              <div className="invalid-feedback">{t('Please Enter First Name')}</div>
            </div>
            <div className="form-group col-md-6">
              <label className="fw-600">{t('Last Name')}</label>
              <input autoComplete="off" type="text" className="form-control saw-input" name="lastName" placeholder={t('Enter Last name')} value={userDetails.lastName} onChange={handleChange} />
            </div>
            <div className="form-group col-md-6">
              <label className="fw-600">{t('Email')}</label>
              <input autoComplete="off" disabled type="text" className="form-control saw-input" name="email" placeholder={t('name@domain.ext')} pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" value={userDetails.email} onChange={handleChange} required />
              <div className="invalid-feedback">{t('Please Enter Valid Email')}</div>
            </div>
            <div className="form-group col-md-6">
              <label className=" fw-600">{t('Phone Number')}</label>
              <PhoneInput international defaultCountry={localCountryStr} placeholder="Enter phone number" value={userDetails.phone || undefined} onChange={(data) => phoneNumberChange(data || '')} className="form-control" />
              <div className="invalid-feedback fs-13">{t('Please Enter Phone Number')}</div>
              {formSubmitted && userDetails.phone && !isValidPhoneNumber(userDetails.phone) ? <div className="text-danger">{t('Invalid phone number')}</div> : null}
            </div>
            <div className="form-group pl-3 d-md-flex">
              <span className="text-nowrap">Contact Preference:</span>
              <div className="d-flex w100 ml-md-4">
                <div className="form-check-label d-flex  fs-14">
                  <input
                    type="checkbox"
                    checked={userDetails.preferredContact === 'Email'}
                    onChange={(e) =>
                      setUserDetails({
                        ...userDetails,
                        preferredContact: 'Email',
                      })
                    }
                    className=" saw-check-box  valid"
                    id="interest-email"
                  />
                  <div className="">Email</div>
                </div>
                <div className="form-check-label d-flex  ml-4 fs-14">
                  <input
                    type="checkbox"
                    checked={userDetails.preferredContact === 'Phone'}
                    onChange={(e) =>
                      setUserDetails({
                        ...userDetails,
                        preferredContact: 'Phone',
                      })
                    }
                    className="  saw-check-box"
                    id="interest-phone"
                  />
                  <div className="">Phone</div>
                </div>
                <div className="form-check-label d-flex  ml-4 fs-14">
                  <input
                    type="checkbox"
                    checked={userDetails.preferredContact === 'Phone Text'}
                    onChange={(e) =>
                      setUserDetails({
                        ...userDetails,
                        preferredContact: 'Phone Text',
                      })
                    }
                    className="  saw-check-box"
                    id="interest-sms"
                  />
                  <div className="">SMS</div>
                </div>
              </div>
            </div>
            <div className="row justify-content-between  mt-2 pl-4 pr-4 ">
              {' '}
              <button type="submit" className="btn btn-grad mw-45" onClick={submit}>
                {t('Save Changes')}
              </button>
              <button type="button" className="btn btn-outline-primary mw-45" onClick={() => logoutProfile()}>
                {t('Logout')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(Profile);
